import { useClient } from '@entities/clients';
import { useGroups } from '@entities/common/groups';
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Link, useLocation, useParams } from 'react-router-dom';
import { ArrowShortRight } from '@shared/assets';
import type { Group } from '@shared/types/common';
import { Card, IconButton } from '@shared/ui';
import * as st from './styles.module.scss';

type PT = {
  onRedirect?: () => void;
};
export const GroupsField = ({ onRedirect }: PT): JSX.Element => {
  const { state } = useLocation();
  const { clientId } = useParams();
  const {
    groups,
    selectedGroups,
    initialGroupsForPublication,
    setPrevSelectedGroupsFunc,
    setSelectedGroups,
    isSelectedAtAnyGroups,
  } = useGroups();
  const { control, getValues } = useFormContext();
  const { client } = useClient(Number(clientId));

  const autoGroup: Group | undefined = groups.find((group) => group.id === state?.groupId);

  useEffect(() => {
    const initGroups = () => {
      if (clientId !== 'new' && client && selectedGroups.length === 0) {
        initialGroupsForPublication(groups, client.user.custom_groups, []);
      }

      if (clientId === 'new' && !client) {
        if (state?.groupId && autoGroup && !isSelectedAtAnyGroups(autoGroup))
          setSelectedGroups([autoGroup]);
      }
    };

    initGroups();
  }, [client]);

  return (
    <>
      <section className={st.wrapper}>
        <h3>Группы</h3>
        <Card className={st.card}>
          <Controller
            control={control}
            name="custom_groups"
            defaultValue={selectedGroups}
            render={({ field: { value } }) => (
              <Link to={`/clients/clients/edit/${clientId}/select-group`}>
                <div
                  className={st.container}
                  onClick={() => {
                    onRedirect?.();
                    setPrevSelectedGroupsFunc(selectedGroups);
                  }}
                >
                  <div className={st.container__groups}>
                    <div className={st.container__groups__onlyGroup}>
                      {selectedGroups.length > 0 &&
                        selectedGroups.map((group: Group) => {
                          if (group.special_type === null)
                            return (
                              <div className={st.group} key={Math.random()}>
                                {group.name}
                              </div>
                            );
                        })}
                    </div>
                  </div>
                  {(selectedGroups.length === 0 ||
                    selectedGroups[0].special_type === 'without_group') && (
                    <div className={st.container__right}>
                      <IconButton variant="dark">
                        <ArrowShortRight />
                      </IconButton>
                    </div>
                  )}
                </div>
              </Link>
            )}
          />
        </Card>
      </section>
    </>
  );
};
